export function FlashbangIcon({ className = "w-5 h-5" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="8" cy="3" r="1.7" fill="none" stroke="#a8a8a8" strokeWidth="0.9" />
      <line x1="8" y1="4.7" x2="8" y2="6.2" stroke="#a8a8a8" strokeWidth="0.8" />
      <path
        d="M9.5 4.2 L13 4.2 Q14 4.2 14 5.2 L14 7"
        stroke="#888"
        strokeWidth="1.1"
        strokeLinecap="round"
        fill="none"
      />
      <rect x="9" y="6.5" width="6" height="2.4" rx="0.3" fill="#222" />
      <rect x="7" y="9" width="10" height="12" rx="1.5" fill="#a4a66a" />
      <rect x="7" y="9" width="10" height="2" fill="#7d7e4d" />
      <rect x="7" y="13.5" width="10" height="2.5" fill="#ede4c2" />
      <rect x="7" y="13" width="10" height="0.5" fill="#d4b840" />
      <rect x="7" y="16" width="10" height="0.5" fill="#d4b840" />
      <rect x="7" y="19.5" width="10" height="1.5" fill="#8a8c52" />
      <rect x="7.5" y="10.5" width="0.6" height="9.5" fill="#b8ba7a" opacity="0.6" />
    </svg>
  );
}
